export enum NAVIGATION_LINKS {
  quotes = "/shipments/quotes",
  domestic = "/domestic",
  bookingTemplates = "/shipments/templates",
}

export enum PAGE_MODE {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  COPY = "COPY",
}

export const FALLBACK_NAVIGATION = `${process.env.MainServiceWeb}`;
